import { makeAutoObservable } from "mobx";
import { FilterConnection } from "./models";
export class FilterStoreImpl {
    constructor(rootStore) {
        this.filters = [];
        this.connector = FilterConnection.and;
        this.rootStore = rootStore;
        makeAutoObservable(this);
    }
    createFilter(filter) {
        this.filters.push(filter);
    }
    changeFilter(oldValue, oldColumnId, filter) {
        this.filters = this.filters.map((f) => f.value === oldValue && ((oldColumnId && f.column == oldColumnId) || !oldColumnId) ? filter : f);
    }
    removeFilter(toRemove) {
        this.filters = this.filters.filter((filter) => filter.value !== toRemove.value || (toRemove.column && filter.column !== toRemove.column));
    }
    setConnector(connector) {
        this.connector = connector;
    }
    getCurrentFilterAsString() {
        if (this.filters) {
            let wrappedConnector = " " + this.connector + " ";
            return this.filters
                .map((filter) => {
                let column = "";
                if (filter.column) {
                    column = filter.column + " ";
                }
                return column + filter.op + " " + filter.value;
            })
                .join(wrappedConnector);
        }
        return "";
    }
}
